import React from 'react';
import { FadeIn } from './FadeIn';
export function Contact() {
  return <section id="contacto" className="py-32 md:py-48 px-6 md:px-12 bg-navy-light border-t border-steel text-center" data-id="element-26" data-mp="2lrpkwsbbtomt">
      <div className="max-w-3xl mx-auto" data-id="element-27" data-mp="316aas6i44oy2">
        <FadeIn data-id="element-28" data-mp="3173hj7h2neg7">
          <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-muted mb-8 block" data-id="element-29" data-mp="318o0dzu0x8y8">
            05 — Contacto
          </span>

          <h2 className="font-display text-4xl md:text-5xl text-cream leading-[1.05] mb-12" data-id="element-30" data-mp="3sxzj3bxolwo6">
            Para consultas formales
          </h2>

          <div className="space-y-8" data-id="element-31" data-mp="3owxrnha0aowr">
            <div data-id="element-32" data-mp="3k561v8yocn7o">
              <a href="mailto:support@instanthandbook.com" className="text-xl md:text-2xl text-cream hover:text-gold transition-colors duration-300 font-light tracking-wide" data-id="element-33" data-mp="3k4mh7khn3kpy">
                support@instanthandbook.com
              </a>
            </div>

            <div className="w-12 h-[1px] bg-steel mx-auto" data-id="element-34" data-mp="gi5ppgvwgi26"></div>

            <div className="text-muted font-semibold uppercase tracking-[0.15em] text-sm leading-loose" data-id="element-35" data-mp="bouhpcfcpv8o">
              <p data-id="element-36" data-mp="3jw4ie0q2rkzy">BPF LLC</p>
              <p data-id="element-37" data-mp="3jxxggrmmgwwc">Wyoming · Estados Unidos</p>
              <p data-id="element-38" data-mp="3otmhz0i7cnva">Operación 100% Online</p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}